module.exports = __webpack_public_path__ + "static/media/TableOrderPaymentOptionsScreen.61fba68f.png";